(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('crm-tag', {
            parent: 'entity',
            url: '/crm-tag',
            data: {
                authorities: [],
                pageTitle: 'CrmTags'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/crm-tag/crm-tags.html',
                    controller: 'CrmTagController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                    var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_CRM_TAG];
                    return Auth.loadActionsAccess(actions).$promise;
                }]
            },
            onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_CRM_TAG, access);
            }]
        })
        .state('crm-tag.new', {
            parent: 'crm-tag',
            url: '/new',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function($stateParams, $state, $uibModal,  Auth, ACTIONS, access) {
                if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_CRM_TAG, access)) {
                    $uibModal.open({
                        templateUrl: 'app/entities/crm-tag/crm-tag-dialog.html',
                        controller: 'CrmTagDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'md',
                        windowTopClass: 'custom-dialog-styles',
                        resolve: {
                            entity: ['CoreService', function (CoreService) {
                                return {
                                    name: null,
                                    id: null,
                                    corporation: CoreService.getCorporation()
                                };
                            }]
                        }
                    }).result.then(function () {
                        $state.go('crm-tag', null, {reload: 'crm-tag'});
                    }, function () {
                        $state.go('crm-tag');
                    });
                }
            }]
        })
        .state('crm-tag.edit', {
            parent: 'crm-tag',
            url: '/{id}/edit',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access' ,function($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_CRM_TAG, access)) {
                    $uibModal.open({
                        templateUrl: 'app/entities/crm-tag/crm-tag-dialog.html',
                        controller: 'CrmTagDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'md',
                        windowTopClass: 'custom-dialog-styles',
                        resolve: {
                            entity: ['CrmTag', function (CrmTag) {
                                return CrmTag.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('crm-tag', null, {reload: 'crm-tag'});
                    }, function () {
                        $state.go('^');
                    });
                }
            }]
        })
        .state('crm-tag.delete', {
            parent: 'crm-tag',
            url: '/{id}/delete',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_CRM_TAG, access)) {
                    $uibModal.open({
                        templateUrl: 'app/entities/crm-tag/crm-tag-delete-dialog.html',
                        controller: 'CrmTagDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        windowTopClass: 'custom-dialog-styles',
                        resolve: {
                            entity: ['CrmTag', function (CrmTag) {
                                return CrmTag.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('crm-tag', null, {reload: 'crm-tag'});
                    }, function () {
                        $state.go('^');
                    });
                }
            }]
        });
    }

})();
